(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SuperLoopController', SuperLoopController);

    SuperLoopController.$inject = ['Collectivity', 'Company', 'CollectivitySize', 'CompanyStatus', 'Sector', 'Profile', 'Search'];

    function SuperLoopController(Collectivity, Company, CollectivitySize, CompanyStatus, Sector, Profile, Search) {
        var vm = this;

        vm.mode = null;
        vm.companyStatus = null;
        vm.sector = null;
        vm.collectivitySize = null;
        vm.keyword = '';
        vm.companyStatuses = [];
        vm.sectors = [];
        vm.collectivitySizes = [];
        vm.results = [];
        vm.search = search;

        CollectivitySize.query(storeCollectivitySizes);
        CompanyStatus.query(storeCompanyStatuses);
        Sector.query(storeSectors);
        search();

        function search() {
            switch (vm.mode) {
                case 'company':
                    if (vm.keyword) {
                        Company.search({
                            query: vm.keyword,
                            companyStatusId: vm.companyStatus,
                            sectorId: vm.sector
                        }, function (companies) {
                            vm.results = companies.map(function (el) {
                                el.searchType = 'company';
                                return el;
                            });
                        });
                    } else {
                        Company.query({
                            page: 0,
                            count: 30,
                            companyStatusId: vm.companyStatus,
                            sectorId: vm.sector
                        }, function (companies) {
                            vm.results = companies.map(function (el) {
                                el.searchType = 'company';
                                return el;
                            });
                        });
                    }
                    break;
                case 'collectivity':
                    if (vm.keyword) {
                        Collectivity.search({
                            query: vm.keyword,
                            cityId: vm.city,
                            collectivitySizeId: vm.collectivitySize
                        }, function (collectivities) {
                            vm.results = collectivities.map(function (el) {
                                el.searchType = 'collectivity';
                                return el;
                            });
                        });
                    } else {
                        Collectivity.query({
                            page: 0,
                            size: 30,
                            cityId: vm.city,
                            collectivitySizeId: vm.collectivitySize
                        }, function (collectivities) {
                            vm.results = collectivities.map(function (el) {
                                el.searchType = 'collectivity';
                                return el;
                            });
                        });
                    }
                    break;
                case 'profile':
                    if (vm.keyword) {
                        Profile.search({
                            query: vm.keyword
                        }, function (profiles) {
                            vm.results = profiles.map(function (el) {
                                el.searchType = 'profile';
                                return el;
                            });
                        });
                    } else {
                        Profile.query({
                            page: 0,
                            cityId: vm.city,
                            collectivitySizeId: vm.collectivitySize,
                            size: 30
                        }, function (profiles) {
                            vm.results = profiles.map(function (el) {
                                el.searchType = 'profile';
                                return el;
                            });
                        });
                    }
                    break;
                case null:
                    if (vm.keyword) {
                        Search.query(vm.keyword).then(function (response) {
                            var data = response.data;
                            var collectivities = data.collectivities.map(function (el) {
                                el.searchType = 'collectivity';
                                return el;
                            });
                            var companies = data.companies.map(function (el) {
                                el.searchType = 'company';
                                return el;
                            });
                            var profiles1 = data.profiles['1'].map(function (el) {
                                el.name = el.firstName + ' ' + el.lastName;
                                el.searchType = 'profile';
                                return el;
                            });
                            var profiles2 = data.profiles['2'].map(function (el) {
                                el.name = el.firstName + ' ' + el.lastName;
                                el.searchType = 'profile';
                                return el;
                            });
                            var profiles3 = data.profiles['3'].map(function (el) {
                                el.name = el.firstName + ' ' + el.lastName;
                                el.searchType = 'profile';
                                return el;
                            });
                            vm.results = profiles1
                                .concat(profiles2)
                                .concat(profiles3)
                                .concat(companies)
                                .concat(collectivities)
                        });
                    } else {
                        vm.results = null;
                    }
                    break;
            }
        }

        function storeCollectivitySizes(collectivitySizes) {
            vm.collectivitySizes = collectivitySizes;
        }

        function storeCompanyStatuses(companyStatuses) {
            vm.companyStatuses = companyStatuses;
        }

        function storeSectors(sectors) {
            vm.sectors = sectors;
        }
    }
})();
